import { Platform } from 'react-native';
import { lazy } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import TransactionIconFocused from '../../assets/Icons/TransactionIconFocused';
import TransactionIconUnfocused from '../../assets/Icons/TransactionIconUnfocused';
import ManageLimitIconFocused from '../../assets/Icons/ManageLimitIconFocused';
import ManageLimitIconUnfocused from '../../assets/Icons/ManageLimitIconUnfocused';
import HomeIconFocused from '../../assets/Icons/HomeIconFocused';
import HomeIconUnfocused from '../../assets/Icons/HomeIcon';
import { NavigationProp, RouteProp } from '@react-navigation/native';
import DashboardScreen from '../screens/Dashboard/Dashboard';
import EmailVerification from '../screens/EmailVerification/EmailVerification';
import ROUTE from './routes';
import { BottomTabParamList, PrivateStackParamList } from './types';
import { useAppDispatch, useAppSelector } from '../store/hooks';


const EnterEmail = lazy(() => import("../screens/EnterEmail/EnterEmail"));
const VerifyEmail = lazy(() => import("../screens/VerifyEmail/VerifyEmail"));
const Faqs = lazy(() => import("../screens/Faqs/Faq"));
const VerifyPan = lazy(() => import("../screens/VerifyPan/VerifyPan"));
const InterestCalculator = lazy(() => import("../screens/InterestCalculator/InterestCalculator"));
const ManageLimit = lazy(() => import("@screens/ManageLimit/ManageLimit"));
const AboutUs = lazy(() => import("../screens/AboutUs/AboutUs"));
const WebviewScreen = lazy(() => import("../screens/Webview/WebviewScreen"));
const LendingPartners = lazy(() => import("../screens/UserProfile/LendingPartners"));
const ProductDetails = lazy(() => import("../screens/UserProfile/ProductDetails"));
const ContactUs = lazy(() => import("../screens/UserProfile/ContactUs"));
const VerifyBankAccount = lazy(() => import("@app/screens/VerifyBankAccount/VerifyBankAccount"));
const BankSelect = lazy(() => import("@app/screens/BankSelect/BankSelect"));

import { removeUrlWithoutReload } from '@app/utils';
import Loader from '../screens/Loader/Loader';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useNavigation } from '@react-navigation/native';
import { checkColor, emailDefferingFlag, getParameters, isLASFlowEnabled } from '@app/utils';
import { Theme, themeColorSet } from '@app/theme';
const LMSDasboard = lazy(() => import("@app/screens/LMSDasboard/LMSDasboard"));
const SelectRepayAmount = lazy(() => import("@app/screens/SelectRepayAmount/SelectRepayAmount"));
const EnterWithdrawalAmount = lazy(() => import("@app/screens/EnterWithdrawalAmount/EnterWithdrawalAmount"));
const ConfirmWithdrawAmount = lazy(() => import("@app/screens/ConfirmWithdrawAmount/ConfirmWithdrawAmount"));
const WithdrawalSuccess = lazy(() => import("@app/screens/WithdrawalSuccess/WithdrawalSuccess"));
const FlexiPay = lazy(() => import("@app/screens/FlexiPay/FlexiPay"));
const ConfirmPay = lazy(() => import("@app/screens/ConfirmPay/ConfirmPay"));
const InterestPayment = lazy(() => import("@app/screens/InterestPayment/InterestPayment"));
const ShortfallDetail = lazy(() => import("@app/screens/ShortfallDetail/ShortfallDetail"));
const ShortfallRepay = lazy(() => import("@app/screens/ShortfallRepay/ShortfallRepay"));
const WhatIsShortfall = lazy(() => import("@app/screens/WhatIsShortfall/WhatIsShortfall"));
const PaymentStatus = lazy(() => import("@app/screens/PaymentStatus/PaymentStatus"));
const InterestLearnMore = lazy(() => import("@app/screens/InterestLearnMore/InterestLearnMore"));
const ShortFallLearnMore = lazy(() => import("@app/screens/ShortFallLearnMore/ShortFallLearnMore"));
const RenewalLearnMore = lazy(() => import("@app/screens/RenewalLearnMore/RenewalLearnMore"));
const RenewLoan = lazy(() => import("@app/screens/RenewLoan/RenewLoan"));
const RenewalSummary = lazy(() => import("@app/screens/RenewalSummary/RenewalSummary"));
const RenewalStatus = lazy(() => import("@app/screens/RenewalStatus/RenewalStatus"));
const PleadgeMF = lazy(() => import("@app/screens/PleadgeMF/PleadgeMF"));
const PleadgeMore = lazy(() => import("@app/screens/PleadgeMore/PleadgeMore"));
const RemovePledge = lazy(() => import("@app/screens/RemovePledge/RemovePledge"));
const AccountDetails = lazy(() => import("@app/screens/AccountDetails/AccountDetails"));
const UpdatePhoneNumber = lazy(() => import("@app/screens/UpdatePhoneNumber/UpdatePhoneNumber"));
const MyLoanDetails = lazy(() => import("@app/screens/MyLoanDetails/MyLoanDetails"));
const PledgeHistory = lazy(() => import("@app/screens/PledgeHistory/PledgeHistory"));
const HowtoCloseAccount = lazy(() => import("@app/screens/HowtoCloseAccount/HowtoCloseAccount"));
const SelectCloseReason = lazy(() => import("@app/SelectCloseReason/SelectCloseReason"));
const ConfirmLoanDetails = lazy(() => import("@app/screens/ConfirmLoanDetails/ConfirmLoanDetails"));
const UnpledgeInstructions = lazy(() => import("@app/screens/UnpledgeInstructions/UnpledgeInstructions"));
const PledgeDetails = lazy(() => import("@app/screens/PledgeDetails/PledgeDetails"));
const ElevateLanding = lazy(() => import("@app/screens/ElevateLanding/ElevateLanding"));
const OldForeClosure = lazy(() => import("@app/screens/OldForeClosure/OldForeClosure"));
const RepayDues = lazy(() => import("@app/screens/RepayDues/RepayDues"));
const ElevateSwitching = lazy(() => import("@app/screens/ElevateSwitching/ElevateSwitching"));
const UpdateSuccess = lazy(() => import("@app/screens/UpdateSuccess/UpdateSuccess"));
const FaqScreenRevamp = lazy(() => import("@app/screens/FaqScreenRevamp/FaqScreenRevamp"));
const FaqDetailsScreenRevamp = lazy(() => import("@app/screens/FaqDetailsRevamp/FaqDetailsRevamp"));
const HelpAndSupportRevamp = lazy(() => import("@app/screens/HelpAndSupportRevamp/HelpAndSupportRevamp"));
const PaymentWebView = lazy(() => import("../screens/PaymentWebView"));
const ViewDetails = lazy(() => import("@app/screens/ViewDetail/ViewDetails"));
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Loading from '@app/sharedComponents/Loading/Loading';
import { updatePartnerParams } from '@app/store/slices/platformSlice';

const BankAccountAdd = lazy(() => import("@app/screens/BankAccountAdd/BankAccountAdd"));
const BankBranchSearch = lazy(() => import("@app/screens/bankBranchSearch/BankBranchSearch"));
const NameMismatch = lazy(() => import("@app/screens/NameMismatch/NameMismatch"));
const SupportingDocuments = lazy(() => import("@screens/SupportingDocuments/SupportingDocuments"));
const DigioMandateSign = lazy(() => import("@screens/DigioMandate/DigioMandateSign"));
const AssetPledge = lazy(() => import("@app/screens/AssetPledge/AssetPledge"));
const DSPAgreement = lazy(() => import("@app/screens/DspKfs/DSPAgreement"));
const MFCentralEvaluateFunds = lazy(() => import("@screens/MFCentral/MFCentralEvaluateFunds/MFCentralEvaluateFunds"));
const MFCentralLanding = lazy(() => import("@screens/MFCentral/MFCentralLanding/MFCentralLanding"));
const MFCentralAnchor = lazy(() => import("@screens/MFCentral/MFCentralAnchor/MFCentralAnchor"));
const KYCDocuments = lazy(() => import("@screens/KYC/KYCDocuments/KYCDocuments"));
const KYCPhotoVerification = lazy(() => import("@screens/KYC/KYCPhotoVerification/KYCPhotoVerification"));
const KYCSummary = lazy(() => import("@app/screens/KYC/KYCSummary/KYCSummary"));
const KYCResponse = lazy(() => import("@screens/KYC/KYCResponse/KYCResponse"));
const KYCRedirect = lazy(() => import("@screens/KYC/KYCRedirect/KYCRedirect"));
const LoanOffer = lazy(() => import("@screens/LoanOffer/LoanOffer"));
const KYCPhotoMisMatch = lazy(() => import("@screens/KYC/KYCPhotoVerification/KYCPhotoMisMatch"));
const KYCStepper = lazy(() => import("@screens/KYCStepper/KYCStepper"));

const CreditLoading = lazy(() => import("@screens/CreditLoading/CreditLoading"));
const DigioAutoPayProgress = lazy(() => import("@app/screens/DigioAutoPayProgress/DigioAutoPayProgress"));
const TataESign = lazy(() => import("@app/screens/TataEsign/TataESign"));
const StateSelection = lazy(() => import("@screens/StateSelection/StateSelection"));
const KycAdditonalDetails = lazy(() => import("@screens/KYC/KYCAdditionalDetails/KycAdditonalDetails"));


const LoanOfferEnhanceLimit = lazy(() => import("@app/screens/LoanOfferEnhanceLimit/LoanOfferEnhanceLimit"));
const MfPledgePortfolio = lazy(() => import("@app/screens/MfPledgePortfolio/MfPledgePortfolio"));
const CheckingLimit = lazy(() => import("@app/screens/CheckingLimit/CheckingLimit"));
const ProfolioFromRta = lazy(() => import("@app/screens/PortfolioFromRta/ProfolioFromRta"));
const SetCreditLimit = lazy(() => import("@app/screens/SetCreditLimit/SetCreditLimit"));
const Portfolio = lazy(() => import("@app/screens/Portfolio/Portfolio"));
const CheckCustomerEligibility = lazy(() => import("@screens/CheckCustomerEligibility/CheckCustomerEligibility"));
const CibilCheckLoadingScreen = lazy(() => import("@screens/CibilCheckLoadingScreen/CibilCheckLoadingScreen"));
const AccountBlocked = lazy(() => import("@app/screens/AccountBlocked/AccountBlocked"));
const ManageLimitLandingPage = lazy(() => import("@app/screens/MangeLimitLandingPage/ManageLimitLandingPage"));
const UnlockLimitLanding = lazy(() => import("@app/screens/UnlockLimitLanding/UnlockLimitLanding"));
const MfdShareLinkInit = lazy(() => import("@app/screens/MfdShareLinkInit/MfdShareLinkInit"));
const MfdShareLinkEndJourney = lazy(() => import("@app/screens/MfdShareLinkEndJourney"));
const RedirectionScreen = lazy(() => import("@app/screens/RedirectionJourney/RedirectionScreen"));
import BajajShutDownInfoScreen from '@app/screens/BajajShutDownInfoScreen';
import { PLATFORM_NAME } from '@app/types/regix';
const PaymentLoader = lazy(() => import("@app/screens/PaymentLoader/PaymentLoader"));
import { baseUrl, baseUrlConfig } from '@app/api/apis';
import FetchPortfolio from '@app/screens/FetchPortfolio/FetchPortfolio';
import { useTheme } from '@shopify/restyle';

import ViewAllLoans from '@app/screens/LMSDasboard/components/ViewAllLoans';
import { updateLMSUserDashboard } from '@app/store/slices/commonSlice';
const Stack = createNativeStackNavigator<PrivateStackParamList>();
const Tab = createBottomTabNavigator<BottomTabParamList>();

const UserProfile = lazy(() => import("../screens/UserProfile/UserProfile"));
const TransactionScreen = lazy(() => import("../screens/Transactions/Transactions"));



type TabNavigationProps = {
  navigation: NavigationProp<BottomTabParamList>;
};

type PrivateRoutesProps = {
  userDetails: {
    linkedApplications: Array<{
      currentStepId: string;
    }>;
    linkedBorrowerAccounts: Array<{
      accountHolderEmail: string | null;
    }>;
    linkedCredits: Array<{
      creditId: string;
    }>;
  };
};


type MyTabsProps = {
  navigation: NativeStackNavigationProp<PrivateStackParamList>;
};

function MyTabs({ navigation }: MyTabsProps) {
  const { showVoltBottomNavBar, showManageLimit, showTransactionHistory, showHome, target } = useAppSelector((state) => state.platformParams);
  const showBottomBar = showVoltBottomNavBar && ([showManageLimit, showTransactionHistory, showHome].filter(Boolean).length >= 2);
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const isBFLLoan = useAppSelector((state) => state.commonReducer.isBFLLoan);
  const isLoanCompleted = useAppSelector((state) => state.commonReducer.isLoanCompleted);
  const isLasFlowEnabled = isLASFlowEnabled();

  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const { colors } = useTheme<Theme>()


  if (isLMSUser === null || false) {
    return <Loading />
  }

  const fetchInitialRoute = () => {
    if (Platform.OS === 'web') {
      removeUrlWithoutReload("target")
    }
    if (!target) {
      return ROUTE.DASHBOARD_SCREEN;
    }
    setTimeout(() => {
      dispatch(updatePartnerParams({ "target": "" }))
      if(isLoanCompleted){
        dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
      }
    }, 1000)
    if (target === 'transaction') {
      return ROUTE.TRANSACTION_SCREEN;
    }
    if (target === 'manageLimit') {
      return ROUTE.MANAGE_LIMIT_SCREEN;
    } else {
      return ROUTE.DASHBOARD_SCREEN;
    }

  }



  return (
    <Tab.Navigator
      initialRouteName={fetchInitialRoute()} // Set Transactions as the default tab
      screenOptions={{
        headerShown: false,
        tabBarLabelStyle: { fontSize: 12, fontFamily: "Inter" },
        tabBarStyle: {
          backgroundColor: themeColorSet['bg-fill-primary'], borderTopColor: themeColorSet['border-secondary'], borderTopWidth: 1,
          paddingBottom: 8,
          paddingTop: 8,
          height: 60,
          display: showBottomBar && !isBFLLoan ? 'flex' : 'none',
        },
        tabBarActiveTintColor: themeColorSet['text-action-primary'],
        tabBarInactiveTintColor: '#667085',
        title: 'Volt - Unlock cash from your mutual funds saving',
      }}
    >
      <Tab.Screen
        options={{
          tabBarLabel: 'Home',
          tabBarLabelPosition: 'below-icon',
          tabBarIcon: ({ focused }) => (
            <HomeIconFocused color={focused ? colors['icon-action-primary'] : colors["icon-secondary"]} color1={focused ? colors['icon-emphasis-primary'] : colors["icon-disabled"]} />
          ),
        }}
        name={ROUTE.DASHBOARD_SCREEN}
        component={(isLMSUser && (isLoanCompleted || isLasFlowEnabled === false) ) ? LMSDasboard : DashboardScreen}
      />
      {showTransactionHistory && <Tab.Screen
        options={{
          tabBarLabel: 'Transactions',
          tabBarLabelPosition: 'below-icon',
          tabBarIcon: ({ focused }) => (
            <TransactionIconFocused color={focused ? colors['icon-action-primary'] : colors['icon-disabled']} color1={focused ? colors['icon-emphasis-primary'] : colors["icon-secondary"]}/>
          ),
        }}
        name={ROUTE.TRANSACTION_SCREEN}
        component={TransactionScreen}
      />}
      {showManageLimit && <Tab.Screen
        options={{
          tabBarLabel: 'Manage Limit',
          tabBarLabelPosition: 'below-icon',
          tabBarIcon: ({ focused }) => (
            <ManageLimitIconFocused color={focused ? colors['icon-action-primary'] : colors['icon-disabled']} color1={focused ? colors['icon-emphasis-primary'] : colors["icon-secondary"]}/>
          ),
        }}
        name={ROUTE.MANAGE_LIMIT_SCREEN}
        component={ManageLimit}
      />}
    </Tab.Navigator>
  );
}

const PrivateRoutes = ({ userDetails }: PrivateRoutesProps) => {
  const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
  const userEmailNotExist = userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail === null;
  const platformParams = useAppSelector((state) => state.platformParams);
  const platform = platformParams?.platform;
  const applicationStatus = userDetails?.linkedApplications[0]?.applicationState;

  const firebaseParams = useAppSelector((state) => state.firebaseParams);
  const isProd = baseUrl === baseUrlConfig['production'];

  const isLOSRevampEnabled = (
    (isProd ? firebaseParams?.los_revamp === 'true' : firebaseParams?.los_revamp_staging === 'true')
  );

  const isLOSRevampEnabledMobile = firebaseParams?.los_revamp_app === 'true';


  const isLOSRevampEnabledSuper = Platform.select({
    ios: isLOSRevampEnabledMobile,
    android: isLOSRevampEnabledMobile,
    web: isLOSRevampEnabled
  });

  const emailDefferingFeatureFlag = emailDefferingFlag();

  const [, setInitialRouteName] = useState<keyof PrivateStackParamList | null>(null);

  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const isLoanCompleted = useAppSelector((state) => state.commonReducer.isLoanCompleted);
  const isLasFlowEnabled = isLASFlowEnabled();
  const { showHome } = platformParams
  useEffect(() => {
    if (Platform.OS !== 'web') {
      // BootSplash.hide({ fade: true })
    }
  }, [])

  // useEffect(() => {
  //   const creditId = userDetails?.linkedCredits[0]?.creditId || null; // check if creditId is present then navigate to splash screen for LMS flow
  //   const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
  //   if(creditId!==null || currentStepName === null){
  //     navigation.navigate("SPLASHSCREEN")
  //     return;
  //   }
  // }, [userDetails])



  if (applicationStatus === 'BLOCKED' || applicationStatus === 'DENIED') {
    return <AccountBlocked />
  }


  return (
    <Stack.Navigator
      screenOptions={{
        title: 'Volt - Unlock cash from your mutual funds saving',
        // animation: 'fade', // iOS-like horizontal slide animation
        // gestureEnabled: true,         // Enable swipe gestures
        // gestureDirection: 'horizontal', // Direction of the swipe gesture
      }}
      initialRouteName={Platform.OS === 'web' ? ROUTE.LOADING : ROUTE.HOME}
    >
      {Platform.OS === 'web' && <Stack.Screen
        name={ROUTE.LOADING}
        component={Loader}
        options={{ headerShown: false }}
      />}
      {(showHome || (isLMSUser && (isLoanCompleted || isLasFlowEnabled === false))) &&
        <Stack.Screen
          name="HOME"
          component={MyTabs}
          options={{ headerShown: false }}
        />}
      {
        (emailDefferingFeatureFlag || userEmailNotExist) && <Stack.Screen
          name={ROUTE.VERIFY_EMAIL}
          component={VerifyEmail}
          options={{ headerShown: false }}
        />
      }
      {
        (emailDefferingFeatureFlag || userEmailNotExist) && <Stack.Screen
          name={ROUTE.ENTER_EMAIL}
          component={EnterEmail}
          options={{ headerShown: false }}
        />
      }
      <Stack.Screen
        name={ROUTE.KYC_PAN_VERIFICATION}
        component={VerifyPan}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.USER_PROFILE}
        component={UserProfile}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ABOUT_US}
        component={AboutUs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WEBVIEW_SCREEN}
        component={WebviewScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LENDING_PARTNERS}
        component={LendingPartners}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PRODUCT_DETAILS}
        component={ProductDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONTACT_US}
        component={ContactUs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ}
        component={Faqs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_CALCULATOR}
        component={InterestCalculator}
        options={{ headerShown: false }}
      />
          <Stack.Screen
            name={ROUTE.BANK_ACCOUNT_VERIFICATION}
            component={VerifyBankAccount}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name={ROUTE.KYC_DOCUMENTS}
            component={KYCDocuments}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_DIGIO_RESPONSE}
            component={KYCResponse}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_DIGIO_REDIRECT}
            component={KYCRedirect}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_PHOTO_VERIFICATION}
            component={KYCPhotoVerification}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_SUMMARY}
            component={KYCSummary}
            options={{ headerShown: false }}
          />

        <>
        
        
          <Stack.Screen
            name={ROUTE.BANK_SELECT}
            component={BankSelect}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.BANK_ACCOUNT_ADD}
            component={BankAccountAdd}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.BANK_BRANCH_SEARCH}
            component={BankBranchSearch}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.NAME_MISMATCH}
            component={NameMismatch}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.SUPPORTING_DOCUMENT}
            component={SupportingDocuments}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.DIGIO_MANDATE_SIGN}
            component={DigioMandateSign}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.ASSET_PLEDGE}
            component={AssetPledge}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.DSP_KFS}
            component={DSPAgreement}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFC_FETCH_EVALUTE_FUNDS}
            component={MFCentralEvaluateFunds}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFC_FETCH_LANDING}
            component={MFCentralLanding}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFC_FETCH_ANCHOR}
            component={MFCentralAnchor}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.PLEDGE_CONFIRMATION}
            component={LoanOffer}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_PHOTO_MISMATCHH}
            component={KYCPhotoMisMatch}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_STEPPER}
            component={KYCStepper}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.CREDIT_LOADING}
            component={CreditLoading}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.DIGIO_AUTOPAY_INPROGRESS}
            component={DigioAutoPayProgress}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.SIGN_DESK_ESIGN}
            component={TataESign}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.STATE_SELECTION}
            component={StateSelection}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MF_FETCH_PORTFOLIO}
            options={{ headerShown: false }}
          >
            {(props) => <FetchPortfolio {...props} isFullScreen={true} />}
          </Stack.Screen>
          <Stack.Screen
            name={ROUTE.MF_PLEDGE_PORTFOLIO}
            component={MfPledgePortfolio}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.CHECKING_LIMIT}
            component={CheckingLimit}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.PORTFOLIO_FROM_RTA}
            component={ProfolioFromRta}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.SET_CREDIT_LIMIT}
            component={SetCreditLimit}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.PORTFOLIO}
            component={Portfolio}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.KYC_ADDITIONAL_DETAILS}
            component={KycAdditonalDetails}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.LOAN_OFFER_ENHANCE_LIMIT}
            component={LoanOfferEnhanceLimit}
            options={{ headerShown: false }}
          />

          <Stack.Screen
            name={ROUTE.CHECK_CUSTOMER_ELIGIBILITY}
            component={CheckCustomerEligibility}
            options={{ headerShown: false }}
          />

          <Stack.Screen
            name={ROUTE.CIBIL_CHECK_LOADING_SCREEN}
            component={CibilCheckLoadingScreen}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.ELEVATE_LANDING}
            component={ElevateLanding}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.BLOCKED}
            component={AccountBlocked}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MANAGE_LIMIT_LANDING}
            component={ManageLimitLandingPage}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.UNLOCK_LIMIT_LANDING}
            component={UnlockLimitLanding}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFD_SHARE_LINK_END_JOURNEY}
            component={MfdShareLinkEndJourney}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.MFD_SHARE_LINK_INIT_AUTH}
            component={MfdShareLinkInit}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name={ROUTE.REDIRECTION_JOURNEY_SCREEN}
            component={RedirectionScreen}
            options={{ headerShown: false }}
          />
        </>
      <Stack.Screen
        name={ROUTE.WITHDRAW_AMOUNT}
        component={EnterWithdrawalAmount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_WITHDRAW_AMOUNT}
        component={ConfirmWithdrawAmount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WITHDRAW_SUCCESS}
        component={WithdrawalSuccess}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FLEXI_PAY}
        component={FlexiPay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_PAYMENT_DETAILS}
        component={ConfirmPay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_PAYMENT}
        component={InterestPayment}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHORTFALL_DETAILS}
        component={ShortfallDetail}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHORTFALL_REPAY}
        component={ShortfallRepay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WHAT_IS_SHORTFALL}
        component={WhatIsShortfall}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_STATUS}
        component={PaymentStatus}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_LEARN_MORE}
        component={InterestLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHOTFALL_LEARN_MORE}
        component={ShortFallLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEWAL_LEARN_MORE}
        component={RenewalLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEW_LOAN}
        component={RenewLoan}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.VERIFY_RENEW_LOAN}
        component={RenewalSummary}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEWAL_STATUS}
        component={RenewalStatus}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEADGE_MF}
        component={PleadgeMF}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_MORE}
        component={PleadgeMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.REMOVE_PLEGE}
        component={RemovePledge}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ACCOUNT_DETAILS}
        component={AccountDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UPDATE_PHONE_EMAIL}
        component={UpdatePhoneNumber}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LOAN_DETAILS}
        component={MyLoanDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_HISTORY}
        component={PledgeHistory}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.OLD_FORECLOSURE}
        component={OldForeClosure}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.REPAY_DUES}
        component={RepayDues}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.HOW_TO_CLOSE_ACCOUNT}
        component={HowtoCloseAccount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SELECT_CLOSE_REASON}
        component={SelectCloseReason}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_LOAN_DETAILS}
        component={ConfirmLoanDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UNPLEDGE_INSTRUCTIONS}
        component={UnpledgeInstructions}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_DETAILS}
        component={PledgeDetails}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name={ROUTE.ELEVATE_SWITCHING}
        component={ElevateSwitching}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UPDATE_ACCOUNT_SUCCESS}
        component={UpdateSuccess}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.HELP_AND_SUPPORT_SCREEN_REVAMP}
        component={HelpAndSupportRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ_SCREEN_REVAMP}
        component={FaqScreenRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ_DETAILS_SCREEN_REVAMP}
        component={FaqDetailsScreenRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_WEBVIEW}
        component={PaymentWebView}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.VIEW_DETAILS}
        component={ViewDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_LOADER}
        component={PaymentLoader}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.BAJAJ_SHUTDOWN}
        component={BajajShutDownInfoScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.EMAIL_VERIFICATION}
        component={EmailVerification}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.VIEW_ALL_LOANS}
        component={ViewAllLoans}
        options={{ headerShown: false }}
      />
    </Stack.Navigator>
  );
};
export default PrivateRoutes;
